import React from 'react';
import { isIOS, isSafari } from 'react-device-detect';
import PageLines from './PageLines';
import { LargePageLineText } from './PageLineText';
import { determineStyleBasedOnLineWidth, getFontSize } from 'utils/style-utils';
import { translate } from '../../translations/translator';
const t = key => translate('worksheet', key);

const NameAndDateLines = ({
  fontFamily,
  top = 8,
  left = 0,
  isNarrow = false,
  isCursive = false,
  isWide = false,
  width = 800,
  nameWidth = 200,
  dateWidth = 300
}) => {
  const marginTop = determineStyleBasedOnLineWidth(
    isCursive,
    isNarrow,
    {
      wide: '-35px',
      cursiveAndNarrow: isIOS || isSafari ? '-20px' : '-26px',
      narrow: '-15px',
      cursive: isIOS || isSafari ? '-27px' : '-36px',
      regular: '-24px'
    },
    isWide
  );

  const marginLeftDate = determineStyleBasedOnLineWidth(
    isCursive,
    isNarrow,
    {
      wide: '535px',
      cursiveAndNarrow: '535px',
      narrow: '475px',
      cursive: '500px',
      regular: '535px'
    },
    isWide
  );

  const dashesMargin = determineStyleBasedOnLineWidth(
    isCursive,
    isNarrow,
    {
      wide: '8px -40px 0 0',
      cursiveAndNarrow: '2px 90px 0 0',
      narrow: '5px 100px 0 0',
      cursive: '2px 68px 0 0',
      regular: '5px 95px 0 0'
    },
    isWide
  );
  const dashesLetterSpacing = determineStyleBasedOnLineWidth(
    isCursive,
    isNarrow,
    {
      wide: '25px',
      cursiveAndNarrow: '20px',
      narrow: '20px',
      cursive: '10px',
      regular: '10px'
    },
    isWide
  );
  const fontSize = getFontSize(isCursive, isNarrow, isWide);
  return (
    <PageLines
      width={width}
      isNarrow={isNarrow}
      isWide={isWide}
      style={{
        alignSelf: 'center',
        margin: '42px 25px 0px',
        position: 'relative',
        top: `${top}px`,
        left: `${left}px`
      }}
    >
      <LargePageLineText
        style={{
          width: `${nameWidth}px`,
          marginLeft: '20px',
          fontSize: fontSize,
          marginTop: marginTop
        }}
      >
        <div
          style={{
            fontFamily,
            color: '#000'
          }}
        >
          {t('name')}:
        </div>
      </LargePageLineText>
      <LargePageLineText
        style={{
          justifyContent: 'space-between',
          width: dateWidth,
          marginLeft: marginLeftDate,
          fontSize: fontSize,
          marginTop: marginTop
        }}
      >
        <div
          style={{
            fontFamily,
            color: '#000'
          }}
        >
          {t('date')}:
        </div>
        <div
          style={{
            fontFamily,
            color: '#000',
            margin: dashesMargin,
            letterSpacing: dashesLetterSpacing
          }}
        >
          - -
        </div>
      </LargePageLineText>
    </PageLines>
  );
};
export default NameAndDateLines;
